import { __extends } from "tslib";
import { TicketStatus } from './enums/ticket-status.enum';
import { UserBuilder } from '../common/users/user-builder';
import { Channel } from './channel.enum';
import { UGCItemBuilder } from './ugc-item.builder';
var TicketBuilder = /** @class */ (function (_super) {
    __extends(TicketBuilder, _super);
    function TicketBuilder() {
        var _this = _super.call(this) || this;
        _this.item = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            subject: 'New title',
            content: 'some content',
            user: new UserBuilder().build(),
            creationDate: Date.now() - 3600000,
            lastUpdateDate: Date.now(),
            lastOpenedDate: Date.now(),
            repliesCount: 0,
            locale: 'en',
            ticketNumber: 999950000,
            labels: [],
            channel: Channel.WEB,
            userEmailChanged: false,
            status: TicketStatus.OPEN,
            uri: '/ticket/234324',
            url: 'http://my-support-site/ticket/234324'
        };
        return _this;
    }
    TicketBuilder.prototype.withId = function (id) {
        this.item.id = id;
        return this;
    };
    TicketBuilder.prototype.withLocale = function (locale) {
        this.item.locale = locale;
        return this;
    };
    TicketBuilder.prototype.withTicketNumber = function (ticketNumber) {
        this.item.ticketNumber = ticketNumber;
        return this;
    };
    TicketBuilder.prototype.withRepliesCount = function (repliesCount) {
        this.item.repliesCount = repliesCount;
        return this;
    };
    TicketBuilder.prototype.withSubject = function (title) {
        this.item.subject = title;
        return this;
    };
    TicketBuilder.prototype.withContent = function (content) {
        this.item.content = content;
        return this;
    };
    TicketBuilder.prototype.withLabels = function (labels) {
        this.item.labels = labels;
        return this;
    };
    TicketBuilder.prototype.withUser = function (user) {
        this.item.user = user;
        return this;
    };
    TicketBuilder.prototype.withAttachments = function (attachments) {
        this.item.attachments = attachments;
        return this;
    };
    TicketBuilder.prototype.withCreationDate = function (creationDate) {
        this.item.creationDate = creationDate;
        return this;
    };
    TicketBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.item.lastUpdateDate = lastUpdateDate;
        return this;
    };
    TicketBuilder.prototype.withLastOpenedDate = function (lastOpenedDate) {
        this.item.lastOpenedDate = lastOpenedDate;
        return this;
    };
    TicketBuilder.prototype.withLastAgentReplyDate = function (lastAgentReplyDate) {
        this.item.lastAgentReplyDate = lastAgentReplyDate;
        return this;
    };
    TicketBuilder.prototype.withLastSolvedDate = function (lastSolvedDate) {
        this.item.lastSolvedDate = lastSolvedDate;
        return this;
    };
    TicketBuilder.prototype.withUserEmailChanged = function (userEmailChanged) {
        this.item.userEmailChanged = userEmailChanged;
        return this;
    };
    TicketBuilder.prototype.withInitialUserEmail = function (initialUserEmail) {
        this.item.initialUserEmail = initialUserEmail;
        return this;
    };
    TicketBuilder.prototype.withUrl = function (url) {
        this.item.url = url;
        return this;
    };
    TicketBuilder.prototype.withUri = function (uri) {
        this.item.uri = uri;
        return this;
    };
    TicketBuilder.prototype.withStatus = function (status) {
        this.item.status = status;
        return this;
    };
    TicketBuilder.prototype.build = function () {
        return this.item;
    };
    return TicketBuilder;
}(UGCItemBuilder));
export { TicketBuilder };
//# sourceMappingURL=ticket.builder.js.map